import React from "react";
import { Container, Typography, Divider, Box } from "@mui/material";
import Logo from "../assets/Images/Dajoo.png";
import Header from "../components/Navbar";
import Footer from "../components/Footer";

const Section = ({ title, children, variant = "h6" }) => (
  <Box sx={{ mb: 4 }}>
    <Typography variant={variant} fontWeight="bold" gutterBottom>
      {title}
    </Typography>
    {typeof children === "string" ? (
      <Typography variant="body2" color="textSecondary">
        {children}
      </Typography>
    ) : (
      children
    )}
  </Box>
);

const SubSection = ({ title, children }) => (
  <Box sx={{ ml: 2, mb: 2 }}>
    <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
      {title}
    </Typography>
    <Typography variant="body2" color="textSecondary">
      {children}
    </Typography>
  </Box>
);

const TermsAndConditions = () => {
  return (
    <>
      <Header />
      <Box sx={{ backgroundColor: "#F9FAFB", py: 5 }}>
        <Container maxWidth="md">
          {/* Logo */}
          <Box sx={{ textAlign: "center", mb: 4 }}>
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="/"
              sx={{ mr: 2, mt: 1 }}
            >
              <img
                alt="logo"
                src={Logo}
                style={{ height: "120px", borderRadius: "5px" }}
              />
            </Typography>
          </Box>

          {/* Header */}
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Terms & Conditions
          </Typography>
          <Typography variant="subtitle2" color="textSecondary" gutterBottom>
            This page contains the terms and conditions of service (the “Terms”)
            governing your use of D’Ajoo, Wavepalm Technology Solution Limited’s
            (“Wavepalm”, “we” or “our”) application and related services (the
            “App” or “Platform”). D’Ajoo is a collaborative savings platform
            designed around the traditional rotating savings model commonly
            known as ajo. It enables groups of individuals to contribute a fixed
            amount of money at agreed intervals (daily, weekly, monthly, etc.)
            into a shared pool. At each contribution cycle, one member of the
            group receives the total pooled amount, based on a predetermined
            order selected by participants, and this continues until every
            member of the group has received the collective payout once Please
            carefully review these Terms before using the Wavepalm service. By
            clicking a registration or new account submission button, or by
            otherwise using Wavepalm’s websites, the Platform, networks, mobile
            applications, or other services provided by Wavepalm (collectively,
            the “Services”), or accessing any content provided by Wavepalm
            through the Services, you agree to be bound by the following
            platform use agreement as updated from time to time. We may revise
            these Terms from time to time, and the most current version will be
            posted on our website. Therefore, please check the website regularly
            for updates to these Terms. By continuing to use the Services after
            revisions become effective, you agree to be bound by the revised
            Terms. If you do not agree to the new Terms, please stop using the
            Services.
          </Typography>

          <Divider sx={{ my: 3 }} />

          {/* 1. DEFINITIONS */}
          <Section title="1. DEFINITIONS">
            <Typography variant="body2" color="textSecondary">
              The following definitions relate to these Terms and Conditions:
              <br />
              <br />
              <strong>“Administrative Fee”</strong> means the fee payable by
              Users at the creation of the Group, for the use, operation, and
              maintenance of the Platform. It is calculated based on the
              Administrative Fee and the total number of Users in a Group, as
              determined by Wavepalm and displayed on the Platform.
              <br />
              <br />
              <strong>"Business Days"</strong> means any day other than a
              Saturday, Sunday, or public holiday in the Federal Republic of
              Nigeria on which commercial banks are open for general business in
              Lagos.
              <br />
              <br />
              <strong>“Compulsory Insurance Cover”</strong> or
              <strong>“Cover”</strong> means the mandatory insurance policy
              procured by Wavepalm on behalf of each User upon registration,
              underwritten by the Designated Insurer, which provides protection
              to the Group against loss arising from in the event of a Member's
              Default Event arising from an Insured Event. This insurance policy
              mainly covers death, accidental permanent and total disability,
              and critical illness.
              <br />
              <br />
              <strong>"Contribution"</strong> means the fixed monetary amount
              agreed by Group Members to be paid into the Pool at each
              Contribution Cycle.
              <br />
              <br />
              <strong>"Contribution Cycle"</strong> means the agreed periodic
              interval (whether daily, weekly, fortnightly, monthly, or
              otherwise) at which Contributions are due and a Payout is
              disbursed.
              <br />
              <br />
              <strong>"Default Event"</strong> means the failure of a Group
              Member to make a Contribution by the due date and time specified
              for a Contribution Cycle.
              <br />
              <br />
              <strong>“Default Rate”</strong> means the rate of interest
              applicable to any overdue or unpaid Contribution, as specified on
              the Platform or in the relevant Group terms, accruing from the due
              date for the Contribution until the date of actual payment in
              full.
              <br />
              <br />
              <strong>“Designated Insurer”</strong> means the licensed insurance
              company appointed by Wavepalm from time to time to underwrite the
              Compulsory Insurance Cover.
              <br />
              <br />
              <strong>“Force Majeure”</strong> means any event or circumstance
              beyond the reasonable control of a Party, which prevents or
              materially delays the performance of that Party’s obligations
              under this Agreement. Such events include, but are not limited to:
              acts of God; storm, flood, fire, or other natural disasters;
              epidemic or pandemic; war, armed conflict, or terrorism; civil
              commotion or riots; governmental actions, restrictions, or orders;
              strikes, lockouts, or other industrial disputes (other than those
              involving the affected Party’s own employees); failure of
              utilities; and any other similar events that could not reasonably
              have been foreseen, prevented, or mitigated by the affected Party.
              <br />
              <br />
              <strong>“GAID”</strong> means the Nigeria Data Protection Act 2023
              General Application and Implementation Directive
              <br />
              <br />
              <strong>"Group"</strong> means a collection of registered Users
              who have collectively agreed to participate in a rotating savings
              arrangement through the Platform.
              <br />
              <br />
              <strong>"Group Administrator"</strong> means the User who creates
              and configures the Group and is responsible for administering the
              Group's settings on the Platform.
              <br />
              <br />
              <strong>"Group Member"</strong> means any User who has joined and
              been accepted into a Group.
              <br />
              <br />
              <strong>“Insurance Premium”</strong> means the fee payable by each
              User at the time of registration as consideration for the
              Compulsory Insurance Cover administrative fee and.
              <br />
              <br />
              <strong>“Insured Amount”</strong> means Up to eighty percent (80%)
              of the outstanding Contributions that a defaulting Group Member
              would have been obligated to pay for the remainder of the Savings
              Cycle from the date of the Default Event .
              <br />
              <br />
              <strong>"Insured Event"</strong> means the death, permanent total
              disability, or diagnosis of a listed critical illness of a Group
              Member, occurring during the currency of the Insurance Cover, that
              gives rise to a valid claim under the Compulsory Insurance Cover.
              <br />
              <br />
              <strong>"KYC"</strong> means Know Your Customer procedures, being
              the identity verification and due diligence processes required by
              applicable law and the Platform.
              <br />
              <br />
              <strong>“NDPA”</strong> means the Nigeria Data Protection Act
              2023.
              <br />
              <br />
              <strong>"Platform"</strong> means D’Ajoo, Wavepalm Technology
              Solution Limited’s application, website, and associated services.
              <br />
              <br />
              <strong>"Pool"</strong> means the aggregate of all Contributions
              collected from Group Members during a single Contribution Cycle.
              <br />
              <br />
              <strong>"Payout"</strong> means the disbursement of the total Pool
              to the designated recipient Group Member at the end of a
              Contribution Cycle, in accordance with the predetermined payout
              order.
              <br />
              <br />
              <strong>"Prohibited Conduct"</strong> has the meaning given in
              Clause 8.1.
              <br />
              <br />
              <strong>“Rotation Order”</strong> means the predetermined sequence
              in which Group Members are entitled to receive the Pool, fixed at
              Group inception and binding on all Group Members for the duration
              of the Savings Cycle.
              <br />
              <br />
              <strong>“Savings Cycle”</strong> means the full period of a
              Group's operation, beginning from the first Contribution Cycle and
              ending when every Group Member has received the Pool once.
              <br />
              <br />
              <strong>"User"</strong> means any individual who has registered an
              account on the Platform.
              <br />
              <br />
              <strong>“We”</strong> or <strong>“Us”</strong> or
              <strong>“Our”</strong> means Wavepalm Technology Solution Limited
              <br />
              <br />
              <strong>“Website”</strong> includes the web portal and log-in page
              provided by us as a means of utilizing the Services.
              <br />
              <br />
              <strong>“You”</strong> or <strong>“Your”</strong> means the
              Customer.
            </Typography>
          </Section>

          {/* 2. NATURE AND SCOPE OF THE PLATFORM */}
          <Section title="2. NATURE AND SCOPE OF THE PLATFORM">
            <SubSection title="2.1.">
              The Platform is a technology facilitation service that enables
              Groups of Users to organise and administer rotating savings
              arrangements or equivalent cooperative savings arrangements. The
              Platform provides the technological infrastructure through which
              Users manage Contributions and Payouts.
            </SubSection>
            <SubSection title="2.2.">
              Wavepalm is not a bank, financial institution, money lender,
              deposit-taking entity, investment manager, payment service
              provider, or financial intermediary. Nothing in these Terms shall
              be construed as creating a financial services relationship,
              debtor-creditor relationship, or fiduciary relationship between
              the Platform Operator and any User.
            </SubSection>
            <SubSection title="2.3.">
              Wavepalm does not at any time hold, keep custody, manage, or
              control the Contributions or Pool on behalf of any User. All fund
              flows are processed exclusively through third-party licensed
              payment processors, the terms and conditions of which are
              separately applicable to Users.
            </SubSection>
            <SubSection title="2.4.">
              Wavepalm makes no representation, warranty, or guarantee that any
              Payout will be made to any User, that any Contribution will be
              recoverable, or that any Group will complete its full savings
              cycle. The Platform facilitates coordination between Users only.
            </SubSection>
            <SubSection title="2.5.">
              Users acknowledge that the rotating savings arrangement is a
              private contractual arrangement between Group Members. The
              Platform Operator is not a party to any agreement between Group
              Members and assumes no obligation or liability arising from such
              arrangements.
            </SubSection>
          </Section>

          {/* 3. REGISTRATION */}
          <Section title="3. REGISTRATION">
            <SubSection title="3.1.">
              As a condition of your use of the Services, you will be required
              to register and create an account. You must complete the
              registration process by providing Wavepalm with current, accurate,
              and complete information as may be required in the registration
              form. Such information may include certain personal information,
              such as your name and email address, all of which will be subject
              to our Privacy Notice . You agree to promptly update the
              information provided during registration as may be necessary to
              keep it current and accurate. You also agree to protect Your
              passwords and take full responsibility for Your own, and
              third-party, use of Your accounts. You agree that you are 18 years
              of age or older.
            </SubSection>
            <SubSection title="3.2.">
              You may register only one account on the Platform. The creation of
              multiple accounts by the same individual is a violation of these
              Terms and may result in the suspension or permanent termination of
              all associated accounts and the forfeiture of any pending Payouts.
            </SubSection>
            <SubSection title="3.3.">
              You are responsible for maintaining the confidentiality of your
              login credentials and solely responsible for all actions taken via
              your account. You must immediately notify us of any unauthorised
              access to or use of your account. The Platform Operator shall not
              be liable for any loss or damage arising from your failure to
              protect your account credentials.
            </SubSection>
            <SubSection title="3.4.">
              We reserve the right to refuse registration to, or to terminate
              your account at our sole discretion, including where we reasonably
              suspects fraudulent, illegal, or abusive conduct.
            </SubSection>
          </Section>

          {/* 4. USE OF THE APPLICATION */}
          <Section title="4. USE OF THE APPLICATION">
            <SubSection title="4.1.">
              By agreeing to this Terms, you represent and warrant that: (a) you
              are at least 18 years of age ; (b) you have not previously been
              suspended or removed from the Services; (c) your registration and
              your use of the Services will comply with all applicable laws and
              regulations; (d) all information you provide to Wavepalm,
              including information submitted as part of the KYC Process, is and
              will at all times remain accurate, complete, current, and not
              misleading; and (e) you acknowledge that you are solely liable
              for, and shall indemnify Wavepalm against, any loss, claim, or
              liability suffered by Wavepalm arising directly or indirectly from
              any breach of the representation in (d) above.
            </SubSection>
            <SubSection title="4.2.">
              You agree that the information you provide is accurate and that
              you will keep it accurate and up-to-date at all times.
            </SubSection>
            <SubSection title="4.3.">
              By using the Platform or App, you agree not to: (a) Reproduce,
              modify, distribute, display, or otherwise provide access to,
              create derivative works from, decompile, disassemble, or reverse
              engineer any portion of the Platform or App, except as explicitly
              permitted under this Terms; (b) Remove or modify any copyright or
              other intellectual property notices that appear on the Platform or
              App; (c) Use the Platform or App in any way that is unlawful, or
              harms Wavepalm, its service providers, suppliers, or any other
              user; (d) Distribute or post spam, chain letters, pyramid schemes,
              or similar communications through the Platform or App; (e)
              Impersonate another person or misrepresent your affiliation with
              another person or entity; (f) Upload invalid data, viruses, worms,
              or other software agents to the Platform or App; (g) Interfere
              with, or compromise the system integrity or security of the
              Platform or App, or otherwise bypass any measures Wavepalm may use
              to prevent or restrict access to the Platform or App; (h) Conduct
              automated queries (including screen and database scraping,
              spiders, robots, crawlers, bypassing "captcha" or similar
              precautions, and any other automated activity with the purpose of
              obtaining information from the Platform or App) on the Platform or
              App; (i) Use any of Wavepalm’s trademarks without approval,
              including but not limited to using them as part of your business
              name, screen name, or email address on the Platform or App; (j)
              Access or use any of the Platform or App to develop competitive
              products or services; or (k) Attempt to, or permit or encourage
              any third party to, do any of the above.
            </SubSection>
            <SubSection title="4.4.">
              If you violate any of the rules contained herein, Wavepalm may
              immediately suspend, revoke, or restrict your account (and any
              related accounts). Wavepalm shall notify you of the suspension,
              and revocation, within twenty-four (24) hours of taking action as
              well as the details of the violation. Wavepalm may reactivate your
              account (subject to any applicable costs) when you rectify the
              violation to its satisfaction.
            </SubSection>
            <SubSection title="4.5.">
              You shall be solely responsible for indemnifying, defending, and
              holding harmless Wavepalm, and all of its owners and officers, for
              any claims, causes of action, or liability arising from any
              misrepresentations uploaded or posted by you on your Account.
              Wavepalm HEREBY DISCLAIMS ALL WARRANTIES AND CONDITIONS, WHETHER
              EXPRESS OR IMPLIED, INCLUDING THE IMPLIED WARRANTIES OR CONDITIONS
              OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE.
            </SubSection>
          </Section>

          {/* 5. IDENTITY VERIFICATION AND KYC OBLIGATIONS */}
          <Section title="5. IDENTITY VERIFICATION AND KYC OBLIGATIONS">
            <SubSection title="5.1.">
              You agree, as a condition of accessing the Platform's contribution
              and payout functionality, to satisfactorily complete the
              Platform's identity verification process ("KYC Process"). The KYC
              Process may require the submission of government-issued
              identification, proof of address, biometric data, bank account
              verification, and such other information as the Platform Operator
              may require from time to time. You hereby consent to the
              processing of your personal data for the purposes of identity
              verification and other related processes
            </SubSection>
            <SubSection title="5.2.">
              We reserve the right to decline, suspend, or withdraw KYC approval
              at any time if, in our sole discretion, we are not satisfied with
              the authenticity, accuracy, or completeness of the information
              provided.
            </SubSection>
            <SubSection title="5.3.">
              By registering on the Platform, you expressly acknowledge and
              consent to the enforcement actions set out in this Clause 5.3 in
              the event that you are found to have committed Identity Fraud. A
              User who provides false, misleading, forged, or stolen identity
              documentation during the KYC Process ("Identity Fraud") shall be
              immediately suspended from accessing or using the Platform, and
              Wavepalm may, without further notice and without any obligation to
              the User: (a) freeze the User’s account; (b) cease or suspend all
              pending or future transactions; (c) restrict the User from
              participating in any savings group or using any part of the
              Services; and (d) permanently bar the User from re-registering on
              the Platform. The User expressly agrees that any Payout previously
              made to such User shall, to the extent permitted by applicable
              law, be withheld, reversed, or subject to recovery action, and the
              User hereby irrevocably authorises Wavepalm to take such steps as
              are necessary to give effect to such recovery. Wavepalm reserves
              the right to report such User to relevant law enforcement and
              regulatory authorities. The User acknowledges that these
              consequences are proportionate, were disclosed prior to
              registration, and were accepted as a condition of access to the
              Platform.
            </SubSection>
          </Section>

          {/* 6. THIRD PARTY LINKED SERVICES */}
          <Section title="6. THIRD PARTY LINKED SERVICES">
            <SubSection title="6.1.">
              The Platform or App includes links to third-party service
              providers, and Website hosts, as well as materials provided by
              third parties (each, a “Third-Party Provider”), which are not
              under Wavepalm’s control.
            </SubSection>
            <SubSection title="6.2.">
              Third-Party Providers are solely responsible for their services.
              The Platform or App may contain hyperlinks to websites operated by
              parties other than Wavepalm. Such hyperlinks are provided for your
              reference only. You are responsible for your dealings or business
              conducted with any Third-Party Provider arising in connection with
              the Platform or App. Your use of third-party sites, services, or
              products may be subject to associated third-party terms of use and
              privacy policies or other agreements, which you are solely
              responsible for complying with. Wavepalm does not endorse and
              takes no responsibility for such products, services, websites, and
              materials of any Third-Party Provider.
            </SubSection>
            <SubSection title="6.3.">
              By using a tool provided by a Third-Party Provider, you agree that
              Wavepalm may transfer information to the applicable third parties,
              which are not under the control of Wavepalm, as may be necessary
              to enable you to use the tool. If you submit a contact form or
              otherwise indicate your interest in contacting a Third-Party
              Provider, you may receive telemarketing calls from the Third-Party
              Provider using the contact information you provided. Third-Party
              Providers may keep your contact information and any other
              information received by them in processing a contact or other
              request form.
            </SubSection>
            <SubSection title="6.4.">
              We require all third parties to respect the security of your
              personal data and to treat it in accordance with applicable laws.
              We only permit third parties to process your personal data for
              specified purposes and in accordance with our instructions and
              with applicable laws.
            </SubSection>
            <SubSection title="6.5.">
              Wavepalm is not responsible for any damages or costs of any type
              arising out of or in any way connected with your dealings with
              these third parties/Third-Party Providers.
            </SubSection>
            <SubSection title="6.6.">
              Certain aspects of the Services include third-party tools that are
              subject to additional third-party terms, including, but not
              limited to, the following: (a) Third-party payment processors
              (“Payment Partners”) - Some of the Services allow you to use
              Payment Partners to make payments to Wavepalm or for services
              available on or through the App or Platform. Your use of the
              Payment Partners feature is subject to the privacy policies and
              terms and conditions/terms of service of the relevant Payment
              Partners. (b) Identify Verification and Security Services - Some
              of the third-party services will include identity verification
              using the National Identification Number, Bank Verification
              Number, facial verification, and verification of government issued
              document. Your use of the features is subject to the privacy
              policies and terms and conditions/terms of service of the relevant
              third-party service provider. (c) Communication, Analytics &
              Hosting Services: some of the third-party services providers are
              used to facilitate email communications, SMS and One-Time Password
              delivery, platform analytics, performance monitoring, error and
              crash reporting. Your use of the features is subject to the
              privacy policies and terms and conditions/terms of service of the
              relevant third-party service provider. (d) Insurance: Some aspects
              of the Services may involve insurance companies or other insurance
              service providers in connection with risk mitigation, protection
              products, claims administration, or related services made
              available through or in connection with the Platform. Your use of
              any such insurance-related feature or service shall be subject to
              the terms and conditions, policy terms, eligibility requirements,
              and privacy policies of the relevant insurance company or service
              provider. Wavepalm does not underwrite any insurance product and
              is not responsible for the acts, omissions, decisions, coverage
              determinations, or performance of any such insurance company or
              provider.
            </SubSection>
          </Section>

          {/* 7. PAYMENT SERVICES */}
          <Section title="7. PAYMENT SERVICES">
            <SubSection title="7.1.">
              The Services may enable you to access or use third-party wallet,
              banking, and/or payment processing functionality provided by
              regulated financial institutions or payment processors (“Payment
              Partners”). All Contributions and Payouts are processed through
              the Payment Partners. We do not operate the payment rails, hold
              customer funds as a bank, or provide regulated payment services
              unless expressly stated otherwise in a separate written agreement
              with you. To the maximum extent permitted by law, Payment Partners
              are responsible for the provision and operation of their payment
              services as well as compliance with applicable regulations and
              regulatory requirements (including applicable AML/CFT, sanctions
              screening, KYC/identity verification, transaction monitoring,
              reporting, and related controls) within their technical and
              operational control. Your use of such services remains subject to
              the applicable Payment Partner terms and policies. Notwithstanding
              the foregoing, we may support Payment Partners’ compliance
              processes by providing information, implementing platform-level
              controls, and taking restriction/suspension actions under these
              Terms.
            </SubSection>
            <SubSection title="7.2.">
              Wavepalm is not responsible for any delay, failure, error, or loss
              caused by a Payment Partner, including but not limited to payment
              processing delays, failed transactions, incorrect deductions, or
              transaction reversals. You acknowledge that payment processing
              timelines are subject to the operational procedures of the Payment
              Partner and your own financial institution.
            </SubSection>
            <SubSection title="7.3.">
              Wavepalm does not guarantee that Payouts will be disbursed within
              any specific period. Payout timelines are indicative only and may
              vary depending on Payment Partner processing times, network
              conditions, bank processing times, and regulatory requirements.
            </SubSection>
            <SubSection title="7.4.">
              In the event of the insolvency, bankruptcy, or regulatory action
              against a Payment Partner that results in the freezing, loss, or
              unavailability of Contributions or Payouts, Wavepalm shall bear no
              liability to any User for such loss. Your recourse shall be
              exclusively against the Payment Partner and/or any applicable
              deposit protection or investor compensation scheme.
            </SubSection>
            <SubSection title="7.5.">
              Wavepalm shall not be responsible for any foreign exchange
              conversion losses, transaction fees imposed by Payment Partners,
              bank charges, or other third-party costs incurred by Users in
              connection with Contributions or Payouts.
            </SubSection>
            <SubSection title="7.6.">
              Wavepalm shall bear no liability to any User whose account is
              frozen, suspended, or terminated pursuant to AML/CTF compliance
              measures, even if it is subsequently determined that the User was
              not engaged in any wrongdoing.
            </SubSection>
          </Section>

          {/* 8. PROHIBITED CONDUCTS */}
          <Section title="8. PROHIBITED CONDUCTS">
            <SubSection title="8.1.">
              Users must not use the Platform for any of the following
              activities ("Prohibited Conducts"): (a) money laundering,
              terrorist financing, fraud, or any other criminal activity; (b)
              creating or joining a Group with the intent to collect a Payout
              and thereafter default on subsequent Contributions; (c)
              impersonating another person or entity, or using false identity
              information; (d) manipulating the Payout order through collusion,
              bribery, coercion, or technical exploitation; (e) circumventing
              the Platform's security, KYC, or AML systems; (f) using the
              Platform in violation of any applicable law or regulation; (g)
              introducing viruses, malware, or other harmful code into the
              Platform; or (h) engaging in any conduct that could reasonably be
              construed as abusive, harassing, or defamatory toward other Users.
            </SubSection>
            <SubSection title="8.2.">
              We may (but are not obliged to) implement automated and manual
              controls intended to detect Prohibited Conduct, including
              monitoring for suspicious patterns (such as unusual transaction
              behavior, abnormal funding volume/frequency, repeated failed
              verification attempts, and account/device anomalies). We may
              investigate suspected Prohibited Conduct, preserve relevant
              records, and share information with our banking partners, payment
              processors, relevant service providers, and competent authorities
              where we consider it necessary or appropriate (including to comply
              with law, respond to lawful requests, or protect users and the
              Platform). If you suspect Prohibited Conduct, you must report it
              to us via the reporting channels we make available in the
              App/Platform or on our website.
            </SubSection>
            <SubSection title="8.3.">
              Where we reasonably suspect Prohibited Conduct or breach of these
              Terms, we may, without prior notice and in our sole discretion:
              (a) refuse, delay, block, or reverse, any activity or transaction,
              including Payouts or Contributions, pending investigation; (b)
              restrict access to certain features of the Platform or the
              Services; (c) suspend or terminate your account; and/or (d) take
              any other action we consider necessary to protect the Services,
              users, and third parties including notification of relevant
              government agencies, law enforcement and regulatory authorities.
            </SubSection>
            <SubSection title="8.4.">
              A User whose account is terminated for a Prohibited Conduct shall
              forfeit all Contributions made to the Platform and shall have no
              claim against the Platform Operator for any resulting loss.
            </SubSection>
            <SubSection title="8.5.">
              Our right to take action under this Clause is without prejudice to
              any other rights or remedies available to us under these Terms, at
              law, or in equity.
            </SubSection>
          </Section>

          {/* 9. GROUP FORMATION AND GOVERNANCE */}
          <Section title="9. GROUP FORMATION AND GOVERNANCE">
            <SubSection title="9.1.">
              A Group may be created by any eligible, KYC-verified User acting
              as Group Administrator. The Group Administrator is responsible for
              setting the Group's parameters, including the Group Fee, the
              Contribution amount, Contribution Cycle frequency, number of
              members, and payout order mechanism.
            </SubSection>
            <SubSection title="9.2.">
              Group Members and Group Administrator shall be required to pay the
              applicable Administrative Fee and Insurance Premium (as provided
              in Clause 13) before upon the creation each of a Group is created
              and before the commencement of the Savings Cycle. No Group shall
              be activated, and no User shall be permitted to participate in a
              Group, until the applicable Administrative Fee and Insurance
              Premium have been paid in full.
            </SubSection>
            <SubSection title="9.3.">
              Each Group Member, including the Group Administrator, agrees to be
              bound by the Group's parameters as configured at the time the
              Group Member joins. No variation to Group parameters may be made
              after the first Contribution Cycle has commenced unless agreed in
              writing by all Group Members and approved by the Platform.
            </SubSection>
            <SubSection title="9.4.">
              The Rotation Order shall be determined in accordance with the
              method selected by the Group Members (whether by mutual agreement,
              random draw, auction, or such other mechanism as is available on
              the Platform). Once confirmed, the Rotation Order is final and
              binding on all Group Members. The Rotation Order may be changed by
              the Group Administrator upon unanimous consent of the Group
              Members.
            </SubSection>
            <SubSection title="9.5.">
              The Group Administrator does not assume any fiduciary or
              supervisory duty to other Group Members by virtue of their
              administrative role on the Platform. The Group Administrator's
              role is limited to configuring Group settings on the Platform.
            </SubSection>
            <SubSection title="9.6.">
              The Platform Operator is not a party to the Group arrangement and
              assumes no obligation to enforce the terms agreed between Group
              Members or to ensure the due performance of any Group Member's
              obligations.
            </SubSection>
          </Section>

          {/* 10. MEMBER DEFAULT AND CONSEQUENCES */}
          <Section title="10. MEMBER DEFAULT AND CONSEQUENCES">
            <SubSection title="10.1.">
              A Default Event occurs when a Group Member fails to make their
              required Contribution by the deadline specified for any
              Contribution Cycle. The Platform shall send automated reminders to
              Users prior to the contribution deadline, but Wavepalm assumes no
              responsibility for a User's failure to contribute.
            </SubSection>
            <SubSection title="10.2.">
              Every User shall ensure that there is adequate fund in the User’s
              wallet to cover Contributions by the Group’s agreed contribution
              deadline. Where the Platform is unable, due to insufficient fund
              in a Group Member’s wallet, to collect that Group Member’s
              Contribution due to lack of adequate funds in the Group Member’s
              wallet by the deadline specified for any Contribution Cycle,
              interest shall accrue on the delayed Contribution at the Default
              Rate until the Contribution is either received by the Platform or
              paid by the Designated Insurer. The accrued interest shall be paid
              to the designated recipient Group Member for that Contribution
              Cycle.
            </SubSection>
            <SubSection title="10.3.">
              Where the defaulted Contribution or the interest component is
              covered by insurance, the insured interest amount shall be paid to
              the Group Member designated to receive the Payout for that
              Contribution Cycle. Any accrued interest received from the
              defaulting Group Member or the Designated Insurer shall be for the
              benefit of, and paid to, the designated recipient Group Member for
              that Contribution Cycle.
            </SubSection>
            <SubSection title="10.4.">
              Upon a Default Event, the Platform may, in its sole discretion and
              in accordance with the Group's configured settings, take any or
              all of the following actions: (a) suspend the defaulting Group
              Member's ability to access the Platform or receive any Payout
              pending resolution of the default; (b) notify all other Group
              Members of the occurrence of the Default Event without disclosing
              any information beyond what is operationally necessary; (c)
              withhold the Payout that was due in the relevant Contribution
              Cycle until the defaulting Group Member's Contribution has been
              received in full; (d) permanently remove the defaulting Group
              Member from the Group; and/or (e) blacklist the defaulting User
              from creating or joining future Groups on the Platform.
            </SubSection>
            <SubSection title="10.5.">
              Wavepalm expressly disclaims all liability to any Group Member who
              has not yet received their Payout for any loss or delay in Payout
              arising from a Default Event. Recovery of contributions from a
              defaulting Group Member is a matter exclusively between Group
              Members. The Platform does not act as a guarantor, surety,
              insurer, or debt collector for Group Members.
            </SubSection>
            <SubSection title="10.6.">
              A User who experiences a Default Event acknowledges and agrees
              that: (a) The User remains liable to the other Group Members for
              the full unpaid Contribution amount, accrued interest and any
              resulting losses; (b) Wavepalm may share the User’s identity
              information with third parties such as the Designated Insurer,
              credit bureaus, investigating agencies, to the extent necessary to
              facilitate recovery of unpaid amounts; and (c) Wavepalm may report
              repeated defaults to third-party credit bureaus or financial
              intelligence agencies, where permitted by applicable law.
            </SubSection>
            <SubSection title="10.7.">
              The defaulting Group Member shall indemnify Wavepalm and all other
              Group Members against all costs, expenses, losses, and damages
              suffered as a direct result of the Default Event, including but
              not limited to delayed Payouts, administrative costs incurred by
              Wavepalm, and legal fees incurred in recovering unpaid
              contributions.
            </SubSection>
          </Section>

          {/* 11. GROUP DISPUTES AND PLATFORM NON-INVOLVEMENT */}
          <Section title="11. GROUP DISPUTES AND PLATFORM NON-INVOLVEMENT">
            <SubSection title="11.1.">
              All disputes among Group Members relating to the operation of the
              Group, including disputes about Contribution amounts, payout
              order, alleged defaults, or Group governance, are private matters
              between the relevant Group Members. Wavepalm is not and shall not
              be made a party to any such dispute.
            </SubSection>
            <SubSection title="11.2.">
              Wavepalm shall have no obligation to investigate, mediate,
              adjudicate, or resolve any dispute between Group Members. Any
              request made to Wavepalm to intervene in a Group dispute shall be
              at Wavepalm’s absolute discretion and shall not create any
              precedent or obligation.
            </SubSection>
            <SubSection title="11.3.">
              Where a Group dispute results in legal proceedings, Wavepalm shall
              have no liability to any party in the dispute and shall be
              entitled to be indemnified by the party that initiates or causes
              such proceedings against Wavepalm for all legal costs and expenses
              incurred.
            </SubSection>
            <SubSection title="11.4.">
              Group Members are encouraged to include a dispute resolution
              mechanism (such as peer mediation or escalation to the Group
              Administrator) in their Group agreement. The Platform may, from
              time to time, provide tools or features to facilitate dispute
              resolution between Group Members. Provision of such tools does not
              imply any responsibility on the part of Wavepalm for the outcome
              of any dispute.
            </SubSection>
          </Section>

          {/* 12. GROUP DISSOLUTION AND ABANDONMENT */}
          <Section title="12. GROUP DISSOLUTION AND ABANDONMENT">
            <SubSection title="12.1.">
              A Group shall be considered dissolved if: (a) all Payout cycles
              have been completed and all Group Members have received their
              respective Payouts; (b) all Group Members unanimously agree to
              dissolve the Group before completion; or (c) Wavepalm dissolves
              the Group pursuant to Clauses 8.3 or 10.3.
            </SubSection>
            <SubSection title="12.2.">
              For the avoidance of doubt, any dissolution of a Group pursuant to
              Clause 12.1 shall be at the sole risk of the Group Members, and
              Wavepalm shall bear no responsibility or liability for the
              consequences of such dissolution.
            </SubSection>
            <SubSection title="12.3.">
              If a Group is dissolved before completion of a Savings Cycle due
              to Group Member abandonment, group-wide default, or any other
              reason not attributable to the Platform Operator, the Platform
              shall use commercially reasonable efforts to return any
              unallocated Contributions held by the relevant Payment Partner to
              the contributing Group Members, subject to reasonable deductions
              such as taxes and transaction processing costs. However, the
              Platform Operator makes no warranty that such return will occur
              within any particular timeframe.
            </SubSection>
            <SubSection title="12.4.">
              If the Group Members of a Group unanimously agree to dissolve the
              Group before completion of a Savings Cycle, such Group Members
              shall as a precondition to the dissolution of the Group refund to
              all Group Members all Payouts that had been collected prior to the
              dissolution of the Group. Each Group Member also agree and
              undertake to indemnify, defend, and hold harmless Wavepalm from
              any and all claims and demands that arising as a result of such
              dissolution.
            </SubSection>
            <SubSection title="12.5.">
              The Platform Operator shall not be liable to any Group Member for
              any loss of Contributions, lost Payout opportunity, or
              consequential loss arising from the dissolution of a Group
              including deductions from such Payouts or Contributions,
              regardless of the cause of dissolution.
            </SubSection>
            <SubSection title="12.6.">
              Each Group Member shall indemnify and hold harmless Wavepalm from
              and against any claims, liabilities, losses, and expenses arising
              from or connected to the dissolution of the Group, to the extent
              that such dissolution is attributable to the conduct of that Group
              Member.
            </SubSection>
          </Section>

          {/* 13. COMPULSORY INSURANCE COVER */}
          <Section title="13. COMPULSORY INSURANCE COVER">
            <SubSection title="13.1.">
              As a non-negotiable condition of registration and of participation
              in any Group, each Group Member must obtain and maintain the
              Compulsory Insurance Cover. No Member shall be permitted to join
              or remain in any Group unless the applicable Insurance Premium has
              been paid in full and the Cover has been confirmed as active by
              the Designated Insurer. The Insurance Premium shall be displayed
              to each User prior to completion of registration; registration
              cannot be finalised Group creation; no Group shall be activated,
              and no Savings Cycle shall commence, without confirmed payment of
              the Insurance Premium by each Group Member.
            </SubSection>
            <SubSection title="13.2.">
              The Insurance Premium shall be is an annual premium collected as a
              one-time single payment due in full at Group creation, prior to
              the time commencement of registration the first Contribution
              Cycle. The applicable premium rate is determined by the Designated
              Insurer. The Insurance Premium is non-refundable once the
              Compulsory Insurance Cover has been issued, except where Wavepalm
              cancels a Group before the commencement of the first Contribution
              Cycle, in which case a pro-rated refund may be issued at the
              Wavepalm’s discretion. Wavepalm reserves the right to revise tThe
              Insurance Premium for new registrations Groups may be revised from
              time to time. Premium revisions will not affect Users whose Cover
              is already in force for an active Contribution Cycle.
            </SubSection>
            <SubSection title="13.3.">
              The Compulsory Insurance Cover operates as follows upon a
              confirmed Default Event attributable to an Insured Event: (a) the
              Designated Insurer shall pay the Insured Amount, being the total
              Contributions that the defaulting Group Member would have been
              required to make for the remainder of the Savings Cycle,
              calculated from the date of the first unpaid Contribution to the
              scheduled final Contribution Cycle of the Group; (b) payment of
              the Insured Amount shall be made directly to the Group Member
              entitled to receive the Payout in the same manner as regular
              Contribution by Group Members, ensuring that the Rotation Order
              and disbursement schedule continue with minimum disruption; (c)
              disbursements to subsequent recipients shall proceed in accordance
              with the Rotation Order as soon as the Pool is adequately funded
              by Contributions and/or Insurance proceeds.
            </SubSection>
            <SubSection title="13.4.">
              The Compulsory Insurance Cover is a group credit life insurance
              policy and not a general default protection policy, credit
              guarantee, surety bond, or savings guarantee. You expressly
              acknowledge and agree that the Compulsory Insurance Cover does not
              respond to, and Wavepalm makes no representation that any recovery
              will be available in respect of, any of the following expressly
              does not extend to: (a) any Default Event arising from the
              defaulting Group Member’s own fraud or deliberate criminal
              conduct, as determined by the Designated Insurer in accordance
              with the Insurance Policy; (b) a Default Event arising from a
              Group Member's abscondment, wilful refusal to pay, or any other
              form of outright default not attributable to an Insured Event; (c)
              a Group Member's job loss of employment, loss of income, business
              failure, insolvency, financial hardship, or inability to pay; (d)
              pandemic, epidemic, public health emergency, civil unrest, force
              majeure events, or other external circumstances affecting a Group
              Member’s ability to pay; (e) losses arising from Wavepalm’s own
              operational failures, technology outages, or regulatory action; or
              (f) any claim submitted outside the time limits or procedural
              requirements specified in the Insurance Policy; (g) ordinary
              illness, temporary incapacity, or any medical condition not listed
              as a critical illness in the Insurance Policy; (h) any event
              falling within the exclusions set out in the Insurance Policy,
              including but not limited to suicide within the exclusion period,
              war, terrorism, participation in criminal activity, self-inflicted
              injury, and (save as expressly carved back in respect of COVID-19)
              epidemic or pandemic events; and (i) any Default Event arising
              from Prohibited Conduct as defined in Clause 8.
            </SubSection>
            <SubSection title="13.5.">
              Upon confirming a Default Event attributable to an Insured Event,
              Wavepalm shall, within two (2) Business Days: (a) issue a Default
              Certificate to the Designated Insurer specifying the identity of
              the defaulting Group Member, Group details, the outstanding
              Contribution schedule, and the calculated maximum Insured Amount;
              (b) notify all Group Members of the affected Group of the Default
              Event and the activation of the Compulsory Insurance Cover; (c)
              submit a complete and valid insurance claim to the Designated
              Insurer on behalf of the affected Group; and (d) provide the
              Designated Insurer with all documentation and information
              reasonably required to process the claim promptly.
            </SubSection>
            <SubSection title="13.6.">
              Group Each Members agree and undertake, in the case of a claim by
              a next-of-kin or estate, to procure that any person claiming under
              the Compulsory Insurance Cover in respect of the Member’s
              Contribution Obligations, to: (a) promptly notify Wavepalm of any
              event that may give rise to a claim; (b) submit all documentation
              reasonably required by the Designated Insurer, including but not
              limited to death certificates, medical reports, identification
              documents, and coroner's reports (where applicable); (c) to
              cooperate fully with any investigation, medical examination,
              verification exercise or enquiry by the Designated Insurer in
              connection with a Default Event or claim; and, including by
              providing statements, documentation, or access to transaction
              records as reasonably requested; (d) not do or omit to do anything
              that would prejudice the Designated Insurer's rights of
              subrogation or recovery. Failure to comply with this Clause 13.6
              may result in the Designated Insurer declining the claim, and Wpm
              shall bear no liability for such decline.
            </SubSection>
            <SubSection title="13.7.">
              The Designated Insurer shall process and pay valid insurance
              claims within the timeframe specified in the Insurance Policy.
            </SubSection>
            <SubSection title="13.8.">
              Disbursement to the next scheduled recipient shall proceed in
              accordance with the Rotation Order as soon as the Pool is
              adequately funded, whether by Group Member’s Contributions alone
              or in combination with Insurance proceeds.
            </SubSection>
            <SubSection title="13.9.">
              Upon payment of any amount under the Compulsory Insurance Cover,
              the Designated Insurer is automatically subrogated to the rights
              of the affected Group Members against the defaulting User to the
              extent of the amount paid. Wavepalm shall cooperate fully with the
              Designated Insurer in any subrogated recovery action, including by
              sharing the defaulting User’s or the Group’s account information,
              transaction records, contact details, and Default Event
              documentation, to the extent permitted by the Privacy Policy and
              Applicable Law.
            </SubSection>
            <SubSection title="13.10.">
              Each User, by accepting these Terms and paying the Insurance
              Premium, expressly consents, in accordance with the Nigeria Data
              Protection Act 2023 ("NDPA") and the GAID, to Wavepalm sharing
              their registration data, KYC information, Contribution history,
              Default Event records, and related documentation with the
              Designated Insurer for the purposes of: (a) issuing and
              administering the Insurance Policy; (b) processing claims, (and
              where a claim is made on behalf of a deceased Group Member,
              engaging with the deceased's next-of-kin, personal
              representatives, or estate administrators for the purposes of the
              claim); and (c) pursuing subrogated recovery. This data sharing is
              a condition of the Cover and Platform participation.
            </SubSection>
            <SubSection title="13.11.">
              The Compulsory Insurance Cover is governed by and subject to the
              terms of the Insurance Policy issued by the Designated Insurer, a
              summary of which shall be provided to each User upon registration
              and is available on the Platform at all times. In the event of any
              conflict between these Terms and the Insurance Policy regarding
              the scope, terms, exclusions, or claims procedure of the Cover,
              the Insurance Policy shall prevail. Wavepalm is not the insurer
              and does not guarantee payment under the Insurance Policy. Any
              dispute regarding the Cover or a claim thereunder shall be
              resolved between the relevant User and the Designated Insurer in
              accordance with the Insurance Policy and Applicable Law.
            </SubSection>
            <SubSection title="13.12.">
              Wavepalm’s role in connection with the Insurance Cover is limited
              to that of policyholder and administrator on behalf of Group
              Members. Wpm is not: (i) the insurer, reinsurer, or underwriter of
              the risk; (ii) an insurance broker, agent, or intermediary (save
              to the extent expressly permitted by applicable law and disclosed
              to Users); or (iii) a guarantor of the Designated Insurer's
              obligations under the Insurance MoU.
            </SubSection>
            <SubSection title="13.13.">
              All claims decisions, including whether an Insured Event has
              occurred, the quantum of any payout, and the timing of settlement,
              are made exclusively by the Designated Insurer in accordance with
              the Insurance Policy. Wavepalm has no authority to accept, reject,
              or vary any claim.
            </SubSection>
            <SubSection title="13.14.">
              Wavepalm shall use commercially reasonable efforts to (i)
              facilitate the submission of claims to the Designated Insurer,
              (ii) provide relevant Group and transactional information required
              for claim assessment, and (iii) receive and disburse admitted
              claim proceeds into the Pool. Wpm's obligations in this regard are
              administrative only.
            </SubSection>
            <SubSection title="13.15.">
              Wavepalm reserves the right to replace the Designated Insurer with
              not less than thirty (30) days' prior written notice to all Users
              with active Cover. Any such replacement shall not result in a
              reduction of the 80% coverage level for affect any Group that has
              already commenced. Wavepalm shall notify Users of any such event
              as soon as reasonably practicable but shall have no liability for
              any consequence thereof. Wavepalm gives no undertaking that
              Insurance Cover of any specific scope, sum insured, or premium
              level will be available in perpetuity.
            </SubSection>
            <SubSection title="13.16.">
              The existence of the Compulsory Insurance Cover does not in any
              way diminish, modify, or extinguish any User’s obligation to make
              Contributions in full and on time. A Member who defaults remains
              fully liable to the Group, and to the Designated Insurer (by way
              of subrogation) for all outstanding Contributions and any costs
              associated with the Default Event, notwithstanding any payment
              made under the Cover.
            </SubSection>
          </Section>

          {/* 14. INTELLECTUAL PROPERTY */}
          <Section title="14. INTELLECTUAL PROPERTY">
            <SubSection title="14.1.">
              The intellectual property rights in the Platform and App are owned
              by Wavepalm. The user interfaces, design, information, data, code,
              products, software, graphics, and all other elements of the
              Platform and App (“Wavepalm Materials”) are protected by
              intellectual property and other applicable laws and are the
              property of Wavepalm or Wavepalm’s third-party licensors. Except
              as expressly allowed by this Terms, you may not copy, decompile,
              reverse engineer, adapt, modify, duplicate, circumvent or make use
              of the Wavepalm Materials, and Wavepalm reserves all rights to the
              Wavepalm Materials and Platform or App that are not granted
              expressly in this Terms and in accordance with applicable
              intellectual property laws and regulations.
            </SubSection>
            <SubSection title="14.2.">
              Any unauthorized use of the Platform, App, or Wavepalm Materials
              may constitute an infringement of intellectual property rights and
              may result in suspension or termination of your access to the
              Services, in addition to any other remedies available to Wavepalm
              under applicable law.
            </SubSection>
          </Section>

          {/* 15. INDEMNIFICATION */}
          <Section title="15. INDEMNIFICATION">
            <SubSection title="15.1.">
              You agree to indemnify, defend, and hold harmless Wavepalm from
              any and all claims and demands made by any third party due to or
              arising out of: (a) your breach of these Terms; (b) your access to
              or misuse of the Platform or App being in violation of any law or
              the rights of a third party; (c) your violation of any applicable
              law, regulation, or third-party right; (d) your participation in
              any Group, including any Default Event attributable to you; (e)
              any fraudulent, deceptive, or illegal act committed by you; (f)
              any dispute between you and any other Group Member; (g) any data,
              content, or materials that you upload to, or otherwise make
              available through, the Platform or App in violation of this Terms,
              including but not limited to materials that infringe upon the
              intellectual property rights of other third parties, violate
              applicable laws or regulations, or are harmful, unlawful, obscene,
              defamatory, or otherwise objectionable (“Unauthorized User
              Material”) you upload to, or otherwise make available through, the
              Platform or App; (h) your willful misconduct; and (i) any other
              party’s unauthorized access to and/or use of the Platform or App
              using your account; (j) any misrepresentation, non-disclosure, or
              false statement made by You (or on your behalf) in connection with
              the Compulsory Insurance Cover, whether at enrolment, in the
              course of a claim, or otherwise; (k) any failure by You (or your
              estate or next-of-kin) to comply with Clause 13.6; and (l) any
              recovery action taken by the Designated Insurer against Wavepalm
              in circumstances where the underlying loss is properly
              attributable to You.
            </SubSection>
            <SubSection title="15.2.">
              Wavepalm reserves the right, at its own expense, to assume the
              exclusive defense and control of any matter otherwise subject to
              indemnification by you, and in that case, you agree to cooperate
              with Wavepalm’s defense of that claim.
            </SubSection>
          </Section>

          {/* 16. NO WARRANTIES BY WAVEPALM */}
          <Section title="16. NO WARRANTIES BY WAVEPALM">
            <SubSection title="16.1.">
              Wavepalm provides the Platform or App "as is", "with all faults"
              and "as available", and the entire risk as to satisfactory
              quality, performance, accuracy, and effort is with you. To the
              maximum extent permitted by applicable law, Wavepalm and its
              suppliers make no representations, warranties, or conditions,
              express or implied. Wavepalm and its suppliers expressly disclaim
              any and all warranties or conditions, express, statutory, and
              implied, including without limitation: (a) warranties or
              conditions of your ability, fitness for a particular purpose,
              workmanlike effort, and accuracy; (b) warranties or conditions
              arising through the course of dealing or usage of trade; and (c)
              warranties or conditions of uninterrupted or error-free access or
              use of the Platform or App.
            </SubSection>
            <SubSection title="16.2.">
              No information, whether oral or written, obtained by you through
              the Platform or App or any materials available through the
              Platform or App will create any warranty regarding any Wavepalm or
              the Platform or App that is not expressively stated in this Terms.
            </SubSection>
            <SubSection title="16.3.">
              Wavepalm shall not be liable for any delay or failure to perform
              its obligations under these Terms to the extent that such delay or
              failure results from: (a) any failure, interruption, infiltration,
              corruption, or malfunction of hardware, software,
              telecommunications systems, or data transmission systems not
              caused by Wavepalm’s fraud, willful misconduct, or negligence; (b)
              the suspension, rejection, delay, interception, or reversal of a
              transaction where the transaction is reasonably suspected or
              confirmed to be unauthorized, fraudulent, or poses a security
              risk, or where such action is required or compelled by applicable
              law or a competent authority; or (c) any circumstance beyond
              Wavepalm’s reasonable control, including but not limited to events
              of Force Majeure.
            </SubSection>
            <SubSection title="16.4.">
              Without prejudice to Clause 13, Wavepalm makes no representation,
              warranty, or guarantee that: (a) any claim under the Compulsory
              Insurance Cover will be admitted, settled, or paid within any
              particular timeframe; (b) the Compulsory Insurance Cover is
              adequate to meet any particular Group Member's needs or the full
              extent of any Outstanding Contribution Obligation; or (c) the
              Designated Insurer will remain solvent, licensed, or continue to
              underwrite the Compulsory Insurance Cover.
            </SubSection>
            <SubSection title="16.5.">
              Wavepalm makes no warranty as to the availability, scope,
              adequacy, or continuity of any Insurance Cover procured under
              Clause 13. All matters relating to the Compulsory Insurance Cover
              are subject exclusively to the terms of the Insurance Policy as
              between the Designated Insurer and the insured party.
            </SubSection>
            <SubSection title="16.6.">
              In the event of a technology failure that disrupts an active
              Contribution Cycle, Wavepalm shall use commercially reasonable
              efforts to restore service and resume the affected Contribution
              Cycle as soon as practicable. Wavepalm’s obligation is limited to
              restoration of the Platform; it assumes no financial liability for
              losses incurred during any period of unavailability.
            </SubSection>
            <SubSection title="16.7.">
              Wavepalm may, at its sole discretion, conduct scheduled or
              emergency maintenance on the Platform at any time. Waveplam will
              use reasonable efforts to provide advance notice of scheduled
              maintenance but is not obligated to do so.
            </SubSection>
            <SubSection title="16.8.">
              Wavepalm disclaims all risk for any damage that may result from
              your use of or access to the Platform or App (other than as may be
              due to its fraud, default, or negligence), your dealing with any
              other user, and any materials, including all user and Wavepalm
              Materials, available through the Platform or App. You acknowledge
              that Wavepalm will not be liable for any damage to your property
              (including your computer system or mobile device used in
              connection with the services), or the loss of data that results
              from the use of the Platform or App or the download or use of
              those materials.
            </SubSection>
          </Section>

          {/* 17. LIMITATION OF LIABILITY */}
          <Section title="17. LIMITATION OF LIABILITY">
            <SubSection title="17.1.">
              In no event will Wavepalm or any of its affiliates be liable for
              any indirect, consequential, special, incidental, or punitive
              damages (including damages for loss of profits, goodwill, or any
              other intangible loss) arising out of, based on, or resulting from
              this terms of use set out in this Terms or your use or access, or
              inability to use or access, the Platform or App or any materials
              on the Platform, whether based on (a) breach of contract, (b)
              breach of warranty, (c) negligence, or (d) any other cause of
              action, even if Wavepalm has been advised of the possibility of
              such damages.
            </SubSection>
            <SubSection title="17.2.">
              To the maximum extent permitted by applicable law, Wavepalm
              assumes no liability or responsibility for any (a) errors,
              mistakes, or inaccuracies of materials; (b) personal injury or
              property damage, of any nature whatsoever, resulting from your
              access to or use of the Platform or App; (c) any interruption or
              cessation of transmission to or from the Platform; (d) any bugs,
              viruses, trojan horses, or the like that may be transmitted to or
              through the Platform or App by any third party; (e) any errors or
              omissions in any materials or for any loss or damage incurred as a
              result of the use of any materials posted, emailed, transmitted,
              or otherwise made available through the Platform or App; and/or
              (f) Unauthorized User Material.
            </SubSection>
            <SubSection title="17.3.">
              If, for any reason, any provision which excludes or have the
              effect of excluding Wavepalm’s liability under this Terms is found
              inoperative or declared by a court of competent jurisdiction, to
              be unenforceable or invalid and liability is imposed on Wavepalm,
              then the aggregate liability of Wavepalm and any of its affiliates
              for all claims arising out of or relating to the use of or
              inability to use any portion of the Platform or App or otherwise
              under this Terms, whether in contract, tort or otherwise, is
              limited to the sum earned by Wavepalm in respect of the relevant
              transaction, events or circumstances giving rise to the claims.
              and any of its affiliates for all claims arising out of or
              relating to the use of or inability to use any portion of the
              Platform or App or otherwise under this Terms, whether in
              contract, tort or otherwise, is limited to the sum earned by
              Wavepalm in respect of the relevant transaction, events or
              circumstances giving rise to the claims.
            </SubSection>
          </Section>

          {/* 18. FEEDBACK */}
          <Section title="18. FEEDBACK">
            <Typography variant="body2" color="textSecondary">
              If you choose to provide input and suggestions regarding the
              Platform or App, including those related to any Wavepalm Materials
              (“Feedback”), you thereby grant Wavepalm an unrestricted,
              perpetual, irrevocable, non-exclusive, fully-paid, royalty-free
              right to use the Feedback in any manner and for any purpose,
              including to improve the Platform or App or create other products
              and services.
            </Typography>
          </Section>

          {/* 19. PRIVACY NOTICE AND OTHER GUIDELINES */}
          <Section title="19. PRIVACY NOTICE AND OTHER GUIDELINES">
            <SubSection title="A. Privacy Notice">
              Wavepalm will collect, use, store, and disclose personal
              information in accordance with its Privacy Notice, which is
              incorporated into, and made a part of this Terms.
            </SubSection>
            <SubSection title="B. Other Guidelines">
              Your use of the Platform or App is subject to all additional
              guidelines, rules, and agreements applicable to the Platform or
              App or certain features of the Platform or App that Wavepalm may
              post on, or link to, from the Platform or App, such as rules
              applicable to a particular product or content available through
              the Platform or App. All such terms are incorporated into and made
              a part of this Terms.
            </SubSection>
            <SubSection title="C. Data Protection">
              <Typography variant="body2" color="textSecondary">
                • Wavepalm acknowledges that in providing the Services to you,
                Wavepalm may be exposed to your Personal Data and, where
                applicable, the Personal Data of your employees, customers, and
                clients. It is mutually agreed that all Personal Data provided
                by you to Wavepalm, or to which Wavepalm may be exposed, shall
                constitute private confidential information and where
                applicable, Intellectual Property belonging to you.
                <br />
                <br />• It is mutually agreed that respective obligations under
                the provisions of the Nigerian Data Protection Act 2023 (“NDPA”)
                and any other relevant Nigerian laws, regulations, or
                international standards applicable in Nigeria shall be complied
                with and neither party shall carry out any action in such a way
                as to breach or to cause the other party to breach any of its
                applicable obligations under NDPA.
              </Typography>
            </SubSection>
            <SubSection title="D. Data Processing">
              <Typography variant="body2" color="textSecondary">
                • Wavepalm acknowledges that in providing the Services to you,
                you and Wavepalm may be privy to the Personal Data of Data
                Subjects as defined under NDPA, Wavepalm undertakes that it will
                process the Personal Data in accordance with its Privacy Policy,
                the NDPA, and any other relevant Nigerian laws, regulations, or
                international standards applicable in Nigeria.
                <br />
                <br />
                • It is mutually agreed that the Personal Data of Data Subjects
                may be collected, stored, and processed for the purposes of
                using the Services provided such collection/storage/ processing
                shall be carried out in accordance with NDPA.
                <br />
                <br />• It is agreed that appropriate technical and
                organizational measures to protect the Personal Data of Data
                Subjects against any unauthorized or unlawful processing and
                against accidental loss, destruction, damage, alteration, or
                disclosure shall be mutually implemented. These measures shall
                be appropriate/proportionate to the harm and risk that might
                result from any unauthorized or unlawful processing, accidental
                loss, destruction, or damage to Personal Data and having regard
                to the nature of the Personal Data which is to be protected.
              </Typography>
            </SubSection>
          </Section>

          {/* 20. MISCELLANEOUS */}
          <Section title="20. MISCELLANEOUS">
            <SubSection title="20.1.">
              You agree not to export from anywhere any part of the Platform or
              App provided to you, or any direct product provided through the
              Platform or App, except in compliance with all licenses and
              approvals required under, applicable export laws, rules, and
              regulations.
            </SubSection>
            <SubSection title="20.2.">
              If any part of this Terms is determined to be invalid or
              unenforceable, then the invalid or unenforceable provision will be
              replaced with a valid, enforceable provision that most closely
              matches the intent of the original provision, and the remainder of
              this Terms will continue in effect.
            </SubSection>
            <SubSection title="20.3.">
              The section titles in this Terms are solely used for the
              convenience of the parties and have no legal or contractual
              significance.
            </SubSection>
            <SubSection title="20.4.">
              Wavepalm may assign its rights and responsibilities under this
              Terms, in whole or in part, at any time upon giving general prior
              notice.
            </SubSection>
            <SubSection title="20.5.">
              Wavepalm’s failure to act with respect to a breach by you or other
              Users does not waive Wavepalm’s right to act with respect to
              subsequent or similar breaches.
            </SubSection>
          </Section>

          {/* 21. COMMUNICATIONS */}
          <Section title="21. COMMUNICATIONS">
            <SubSection title="21.1.">
              By using the Platform or App, you consent to receive certain
              electronic communications from Wavepalm as further described in
              the Privacy Notice. Please read the Privacy Notice to learn more.
              You agree that any notices, agreements, disclosures, or other
              communications that Wavepalm sends to you electronically will
              satisfy any legal communication requirements, including that those
              communications be in writing.
            </SubSection>
            <SubSection title="21.2.">
              Communication by you to Wavepalm shall be in writing, and shall be
              delivered personally, via SMS or email, or sent by courier as
              follows:
              <br />
              <br />
              Attention:
              <br />
              Wavepalm Technology Solutions Limited
              <br />
              [.]
            </SubSection>
            <SubSection title="21.3.">
              Any notice given under this Terms shall be in writing and shall be
              delivered personally, via email or sent by courier to the
              registered address as indicated.
            </SubSection>
            <SubSection title="21.4.">
              All notices shall be deemed to be received by the addressee on the
              date of delivery with proof thereof or on the 10th (tenth)
              Business Day after delivery to the courier.
            </SubSection>
          </Section>

          {/* 22. GOVERNING LAW AND DISPUTE RESOLUTION */}
          <Section title="22. GOVERNING LAW AND DISPUTE RESOLUTION">
            <SubSection title="22.1.">
              This Terms shall be governed by the laws of the Federal Republic
              of Nigeria. Any dispute, claim, or action arising out of or in
              connection with the Platform or App and/or these Terms shall be
              referred to and finally resolved by arbitration seated in Lagos,
              Nigeria, in accordance with the Arbitration and Mediation Act
              2023.
            </SubSection>
            <SubSection title="22.2.">
              Any dispute, difference, question, or conflict arising out of or
              in connection with the Platform and App, this Terms, or howsoever
              between the Parties hereto including questions as to the validity
              or otherwise of this Terms shall be amicably resolved between the
              Parties within a period of fifteen (15) Business Days.
            </SubSection>
            <SubSection title="22.3.">
              Where a dispute is not resolved in accordance with clause 22.2, it
              shall be referred to arbitration by a single arbitrator appointed
              by a consensus of the parties hereto or failing such consensus
              within fourteen (14) days of request by a Party for consensus, by
              the Chairman for the time being of the Chartered Institute of
              Arbitration (UK) Nigeria branch. The arbitral proceedings shall be
              conducted in Lagos and in accordance with the Arbitration and
              Mediation Act 2023. The existence of arbitration proceedings
              during the existence of this Terms shall not suspend your
              obligations as contained herein. It is mutually agreed that the
              contents of the arbitral proceedings shall be kept strictly
              confidential. The decision of the Arbitrator and award granted
              shall be final. The right to arbitrate disputes or claims under
              this Terms shall survive its termination
            </SubSection>
          </Section>

          {/* 23. TERMINATION AND AMENDMENTS TO THE TERMS */}
          <Section title="23. TERMINATION AND AMENDMENTS TO THE TERMS">
            <Typography variant="body2" color="textSecondary">
              We may terminate this Agreement with you at any time, without
              advanced notice, where we believe in good faith that you have
              breached these Terms or otherwise believe that termination is
              reasonably necessary to safeguard the rights of other users of the
              Services.
            </Typography>
          </Section>
        </Container>
      </Box>
      <Footer />
    </>
  );
};

export default TermsAndConditions;
